module.exports = __webpack_public_path__ + "assets/83faee9c8789bb7859299bfa1f17be2d.json";